import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect, useRef, useState } from "react"
import List, { type ListItem } from "../../../components/List/List"
import { adminEmployeeMemory } from "../../../Objects/Memory/Memory"
import { useGetAdminEmployee } from "../../../hooks/AdminEmployee/useGetAdminEmployee"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useTranslation } from "react-i18next"
import { AdminEmployee } from "../../../Objects/AdminEmployee/AdminEmployee"
import { AdminEmployeePupop } from "./AdminEmployeePupop"

export const AdminEmployeesPage: React.FC = () => {
  const { t } = useTranslation("adminEmployee")

  const { handleGetAdminEmployee } = useGetAdminEmployee()

  const [isOpen, setIsOpen] = useState(false)

  const [selected, setSelected] = useState<AdminEmployee | null>(null)

  const [employeeCards, setEmployeeCards] = useState<ListItem[]>(() => adminEmployeeMemory.getListCards(true))

  const hasLoadedEmployees = useRef(false)

  const refreshAdminEmployees = () => {
    handleGetAdminEmployee(() => {
      setEmployeeCards(adminEmployeeMemory.getListCards(true))
    })
  }

  useEffect(() => {
    if (hasLoadedEmployees.current) return

    hasLoadedEmployees.current = true

    refreshAdminEmployees()
  })

  const handleAdd = () => {
    setSelected(null)
    setIsOpen(true)
  }

  const handleEdit = (id: number) => {
    const employee = adminEmployeeMemory.findById(id)

    if (employee) {
      setSelected(employee)
      setIsOpen(true)
    }
  }

  return (
    <div className={defaultStyle.containerList}>
      <List
        messageCount={t("list_message_count")}
        messageEmpty={t("list_message_empty")}
        nameFindSearch={t("list_place_holder")}
        data={employeeCards}
        handleAddButton={handleAdd}
        handleRefreshButton={refreshAdminEmployees}
        nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
        handleOnClick={handleEdit}
      />

      {isOpen && (
        <AdminEmployeePupop
          employee={selected}
          title={selected ? t("title_popup_edit_employee") : t("title_popup_create_employee")}
          onSaved={refreshAdminEmployees}
          onClose={() => setIsOpen(false)}
        />
      )}
    </div>
  )
}
